import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    translation: {
      nav: {
        home: "Anasayfa",
        about: "Hakkımızda",
        services: "Hizmetlerimiz",
        contact: "İletişim",
        prices: "Fiyatlar",
        documents: "Sertifikalar ve Raporlar",
        survey: "Survey Hizmetleri & Danışmanlık",
        maintenance: "Periyodik Bakım",
        repair: "Arıza Tespiti",
        parts: "Yedek Parça",
        emergency: "Acil Müdahale",
      },
      home: {
        whoAreWe: "Biz Kimiz?",
        desc1: "Deniz tutkusuyla yola çıkan firmamız, bireysel yat sahiplerine yönelik yenilikçi ve sürdürülebilir çözümler sunma misyonuyla kurulmuştur. Yedek parça temini, bakım-onarım hizmetleri ve teknik danışmanlık alanlarında uzmanlaşmış bir ekibe sahibiz. Her müşterimizin ihtiyaçlarını anlamak ve onlara özel çözümler sunmak için çalışıyoruz.",
        desc2: "Müşteri memnuniyetini ön planda tutarak, yüksek kaliteli hizmetlerimizle sektördeki en güvenilir isimlerden biri olmayı hedefliyoruz.",
        readMore: "Daha Fazla Oku",
      },
      about: {
        whoAreWe: "Biz Kimiz?",
        p1: "Deniz tutkusuyla yola çıkan firmamız, bireysel yat sahiplerine yönelik yenilikçi ve sürdürülebilir çözümler sunma misyonuyla kurulmuştur. Yedek parça temini, bakım-onarım hizmetleri ve teknik danışmanlık alanlarında uzmanlaşmış bir ekibe sahibiz. Her müşterimizin ihtiyaçlarını anlamak ve onlara özel çözümler sunmak için çalışıyoruz.",
        p2: "Müşteri memnuniyetini ön planda tutarak, yüksek kaliteli hizmetlerimizle sektördeki en güvenilir isimlerden biri olmayı hedefliyoruz. Uzman teknisyenlerimiz, her tekneye özel yaklaşımımızla, bakım ve onarım süreçlerini titizlikle yürütmektedir. Amacımız, yat sahiplerinin denizde güvenli, konforlu ve keyifli bir deneyim yaşamalarını sağlamaktır.",
        p3: "Gelişen teknoloji ve yenilikçi çözümlerle, sektördeki en yüksek standartları belirlemeyi amaçlıyoruz. Gelecekte, denizcilik alanında en çok tercih edilen ve saygı duyulan marka olma vizyonumuzla, her adımda mükemmelliği arıyoruz. Bizimle birlikte, deniz yolculuğunuzda güvenilir bir ortak edinin!",
        vision: "Vizyonumuz",
        visionText: "Yedek parça ve bakım-onarım sektöründe lider konumda olmak, deniz tutkunlarının güvenli ve keyifli bir deneyim yaşamasını sağlamak için yenilikçi ve sürdürülebilir çözümler sunmayı hedefliyoruz. Müşteri memnuniyetini en üst düzeyde tutarak, sektördeki en yüksek standartları belirleyen bir marka olmayı ve her tekne sahibinin güvenilir bir çözüm ortağı olarak bizi tercih etmesini sağlamayı amaçlıyoruz.",
        mission: "Misyonumuz",
        missionText: "Bireysel yat sahiplerine denizde güvenli ve sorunsuz bir deneyim sunmayı amaçlayarak, bakım-onarım ve yedek parça alanlarında özel, güvenilir ve sürdürülebilir çözümler geliştiriyoruz. Her tekneye ve her müşteriye özgü bir yaklaşım benimseyerek, uzmanlığımızı yüksek hizmet kalitesiyle bir araya getiriyoruz.",
      },
      contact: {
        title: "Bizimle İletişime Geçin",
        phone: "Telefon",
        email: "E-posta",
        address: "Adres",
        addressValue: "İstanbul / Ümraniye",
        engineer: "GEMİ İNŞAATI MÜHENDİSİ VE SURVEYOR",
      },
      services: {
        title: "HİZMETLERİMİZ",
      },
      pricing: {
        title: "Fiyatlar",
        description: "Yat surveyi, tamir-bakım ve mühendislik danışma hizmetleri için güncel hizmet ücretleri.",
        contactButton: "İletişime Geç",
        ariaLabel: "Fiyat listesi",
        validityNotice: "Fiyatlar 2026 Mayıs ayı içerisinde geçerlidir.",
        survey: {
          title: "Yat Surveyi",
          subtitle: "Tekne boyuna göre hesaplanır",
          unit: "Feet x",
          oldPrice: "25 EUR",
          newPrice: "15 EUR",
          items: [
            "Karina Surveyi",
            "Makine Dairesi Surveyi",
            "Yat Harici Vasıtaların Surveyi",
            "Seyir Tecrubesi",
            "Arma Surveyi",
            "Köprüüstü ve Donanımları Surveyi",
            "Güverte ve Donanımları Surveyi",
            "Güvenlik ve Sertifikalar Surveyi",
            "İç Mekan Surveyi"
          ]
        },
        maintenance: {
          title: "Tamir - Bakım",
          subtitle: "İşçilik odaklı bakım ve arıza hizmetleri",
          items: [
            {
              title: "Motor Mekanik Bakım",
              price: "125 EUR",
              note: "Sadece işçilik ücretidir",
              details: [
                "Yağ değişimi",
                "Filtre değişimi",
                "Impeller değişimi (Gerekli ise)",
                "Kayış değişimi (Gerekli ise)"
              ]
            },
            {
              title: "Arıza Tespit ve Raporlama",
              price: "50 EUR"
            },
            {
              title: "Vinç Bakımları",
              price: "75 EUR / Adet",
              note: "Sadece işçilik ücretidir"
            },
            {
              title: "Irgat Bakımı",
              price: "100 EUR",
              note: "Sadece işçilik ücreti"
            },
            {
              title: "Elektrik Tesisat Bakımları",
              price: "100 EUR",
              note: "Güneş paneli, akü, kablo, sigorta vb. işler için sadece işçilik"
            },
            {
              title: "Acil Durum Müdahale",
              price: "150 EUR",
              note: "Sadece geceleri, sadece işçilik ücreti"
            }
          ]
        },
        consulting: {
          title: "Mühendislik Danışma Hizmetleri",
          subtitle: "Proje dahilinde günlük danışmanlık",
          label: "Proje dahilinde",
          price: "100 EUR / Gün"
        }
      },
      mission: {
        card1Title: "Sizi Dinliyor, Yanınızda Kalıyoruz",
        card1Desc: "Müşteri memnuniyetini en üst düzeyde tutmayı hedefliyoruz. İhtiyacınızı dikkatle analiz ederek, her aşamada yanınızda yer alıyoruz.",
        card2Title: "Yerinde Analiz, Etkili Uygulama",
        card2Desc: "Teknenizin ihtiyaçlarını doğru bir şekilde belirlemek için yerinde analiz yapıyoruz. Uzman ekibimiz, teknenizin tüm bileşenlerini detaylı bir şekilde inceler.",
        card3Title: "Profesyonel Hizmet, Güvenli Teslimat",
        card3Desc: "Hızlı ve yetkin ekibimizle, tüm işlemleri profesyonel bir şekilde tamamlıyoruz. Her aşamada kaliteyi ön planda tutarak, işimizi titizlikle yürütüyoruz.",
      },
      serviceList: {
        s1: {
          name: "Survey Hizmetleri ve Danışmanlık",
          p1: "Anchmar Marine olarak yat ve tekneler için bağımsız teknik danışmanlık ve survey hizmetleri sunmaktayız.",
          p2: "Hizmetlerimiz; tekne alım öncesi incelemeler, kondisyon değerlendirmeleri, hasar tespitleri ve sigorta surveyleri gibi teknik kontrolleri kapsamaktadır.",
          p3: "Denetimler, uluslararası denizcilik standartları ve kabul görmüş survey metodolojileri doğrultusunda tamamen bağımsız ve tarafsız bir yaklaşımla gerçekleştirilmektedir.",
          p4: "Amacımız; tekne sahipleri, alıcılar, sigorta şirketleri ve yatırımcılar için güvenilir teknik bilgi sağlayarak doğru karar verilmesine yardımcı olmaktır.",
          p5: "Hizmet kapsamımız özellikle 24 metreye kadar olan yat ve tekneler için detaylı teknik inceleme ve raporlama süreçlerini içermektedir.",
          p6: "Gerçekleştirilen survey çalışmaları aşağıdaki başlıkları kapsayabilir:",
          p7: "Tekne alım öncesi teknik inceleme (Pre-Purchase Survey)",
          p8: "Kondisyon ve durum tespit surveyleri",
          p9: "Hasar inceleme ve raporlama",
          p10: "Sigorta amaçlı teknik değerlendirmeler",
          p11: "Değerleme ve teknik danışmanlık",
          p12: "Tüm incelemeler tarafsızlık ilkesi doğrultusunda gerçekleştirilmekte olup detaylı teknik raporlarla desteklenmektedir.",
        },
        s2: {
          name: "Periyodik Bakım & Genel Servis",
          desc: "Yat sahiplerinin güvenli ve sorunsuz bir deneyim yaşaması için düzenli periyodik bakım ve genel servis hizmetleri sunuyoruz. Bu hizmetler, teknenizin performansını artırmak, ömrünü uzatmak ve olası sorunları önceden tespit etmek amacıyla uzman teknisyenlerimiz tarafından gerçekleştirilir. Her bakımda, motor, elektrik sistemleri, su sistemleri ve diğer kritik bileşenler detaylı bir şekilde kontrol edilir.",
        },
        s3: {
          name: "Arıza Tespiti ve Onarım Çözümleri",
          desc: "Teknenizde meydana gelen arızaların hızlı ve etkili bir şekilde tespit edilmesi için gelişmiş teknolojiler kullanıyoruz. Uzman ekibimiz, arıza kaynaklarını belirleyerek en uygun onarım çözümlerini sunar. Müşterilerimize, sorunlarının çözümünde güvenilir ve kalıcı alternatifler sağlamak için çalışıyoruz.",
        },
        s4: {
          name: "Orijinal ve Alternatif Yedek Parça Temini",
          desc: "Yatınızın ihtiyaç duyduğu orijinal ve alternatif yedek parçaları temin ediyoruz. Kalite ve güvenilirlikten ödün vermeden, her tekneye uygun yedek parçaları en kısa sürede temin ederek, müşterilerimizin kesintisiz bir deniz deneyimi yaşamalarını sağlıyoruz.",
        },
        s5: {
          name: "Acil Müdahale Hizmetleri (Yakında)",
          desc: "Denizde karşılaşabileceğiniz acil durumlar için hızlı müdahale hizmetleri sunmayı planlıyoruz. Acil durumlar için özel olarak eğitilmiş ekiplerimiz, gerektiğinde hızlı bir şekilde devreye girerek yat sahiplerinin güvenliğini sağlayacaktır.",
        },
      },

      documents: {
        title: "Sertifikalar ve Raporlar",
        certificates: "Sertifikalar",
        reports: "Örnek Raporlar",
        view: "Görüntüle",
        items: {
          cert1: "Serbest Gemi Mühendisi Tescil Belgesi",
          cert2: "Gemi Kontrolüne Yetkili Mühendis Belgesi",
          cert3: "IIMS Üyelik Belgesi",
          cert4: "Liman Kontrol Başarı Belgesi",
          report1: "Ön Alım Survey Raporu - 1",
          report2: "Ön Alım Survey Raporu - 2"
        }
      },

        footer: {
        contactUs: "Bize Ulaşın",
        quickAccess: "Hızlı Erişim",
        slogan: "Yat ve Tekneleriniz için en İyisi",
        privacy: "Gizlilik Politikası",
        kvkk: "KVKK",
        copyright: "© 2026 anchmarmarine.com",
      }
    }
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        about: "About Us",
        services: "Services",
        contact: "Contact",
        prices: "Prices",
        documents: "Certificates and Reports",
        survey: "Survey Services & Consultancy",
        maintenance: "Periodic Maintenance",
        repair: "Fault Detection",
        parts: "Spare Parts",
        emergency: "Emergency Response",
      },
      home: {
        whoAreWe: "Who Are We?",
        desc1: "Our company, founded with a passion for the sea, was established with the mission of providing innovative and sustainable solutions for individual yacht owners. We have a specialized team in spare parts supply, maintenance-repair services and technical consultancy.",
        desc2: "Prioritizing customer satisfaction, we aim to be one of the most reliable names in the industry with our high quality services.",
        readMore: "Read More",
      },
      about: {
        whoAreWe: "Who Are We?",
        p1: "Our company, founded with a passion for the sea, was established with the mission of providing innovative and sustainable solutions for individual yacht owners. We have a specialized team in spare parts supply, maintenance-repair services and technical consultancy.",
        p2: "Prioritizing customer satisfaction, we aim to be one of the most reliable names in the industry with our high quality services. Our expert technicians carry out maintenance and repair processes meticulously with our approach tailored to each vessel.",
        p3: "With developing technology and innovative solutions, we aim to set the highest standards in the industry. Join us as a reliable partner in your sea voyage!",
        vision: "Our Vision",
        visionText: "We aim to be a leader in the spare parts and maintenance-repair sector, offering innovative and sustainable solutions to ensure maritime enthusiasts have a safe and enjoyable experience.",
        mission: "Our Mission",
        missionText: "Aiming to provide a safe and trouble-free experience at sea for individual yacht owners, we develop special, reliable and sustainable solutions in the fields of maintenance-repair and spare parts.",
      },
      contact: {
        title: "Contact Us",
        phone: "Phone",
        email: "E-mail",
        address: "Address",
        addressValue: "Istanbul / Ümraniye",
        engineer: "MARINE ENGINEER AND SURVEYOR",
      },
      services: {
        title: "OUR SERVICES",
      },
      pricing: {
        title: "Prices",
        description: "Current service fees for yacht survey, repair-maintenance and engineering consultancy services.",
        contactButton: "Contact Us",
        ariaLabel: "Price list",
        validityNotice: "Prices are valid during May 2026.",
        survey: {
          title: "Yacht Survey",
          subtitle: "Calculated by vessel length",
          unit: "Feet x",
          oldPrice: "25 EUR",
          newPrice: "15 EUR",
          items: [
            "Hull Survey",
            "Engine Room Survey",
            "Survey of Auxiliary Craft",
            "Sea Trial",
            "Rig Survey",
            "Bridge and Equipment Survey",
            "Deck and Equipment Survey",
            "Safety and Certificates Survey",
            "Interior Survey"
          ]
        },
        maintenance: {
          title: "Repair - Maintenance",
          subtitle: "Labor-focused maintenance and fault detection services",
          items: [
            {
              title: "Engine Mechanical Maintenance",
              price: "125 EUR",
              note: "Labor fee only",
              details: [
                "Oil change",
                "Filter change",
                "Impeller change (if required)",
                "Belt change (if required)"
              ]
            },
            {
              title: "Fault Detection and Reporting",
              price: "50 EUR"
            },
            {
              title: "Winch Maintenance",
              price: "75 EUR / Unit",
              note: "Labor fee only"
            },
            {
              title: "Windlass Maintenance",
              price: "100 EUR",
              note: "Labor fee only"
            },
            {
              title: "Electrical Installation Maintenance",
              price: "100 EUR",
              note: "Labor only for solar panel, battery, cable, fuse and similar works"
            },
            {
              title: "Emergency Response",
              price: "150 EUR",
              note: "Night only, labor fee only"
            }
          ]
        },
        consulting: {
          title: "Engineering Consultancy Services",
          subtitle: "Daily consultancy within the project scope",
          label: "Within project scope",
          price: "100 EUR / Day"
        }
      },
      mission: {
        card1Title: "We Listen, We Stand By You",
        card1Desc: "We aim to keep customer satisfaction at the highest level. By carefully analyzing your needs, we stand by you at every stage.",
        card2Title: "On-Site Analysis, Effective Implementation",
        card2Desc: "We conduct on-site analysis to accurately determine your vessel's needs. Our expert team examines all components in detail.",
        card3Title: "Professional Service, Safe Delivery",
        card3Desc: "With our fast and competent team, we complete all operations professionally. Keeping quality at the forefront at every stage.",
      },
      serviceList: {
        s1: {
          name: "Survey Services & Consultancy",
          p1: "As Anchmar Marine, we provide independent technical consultancy and survey services for yachts and vessels.",
          p2: "Our services cover technical inspections such as pre-purchase surveys, condition assessments, damage surveys and insurance surveys.",
          p3: "Inspections are carried out in a completely independent and impartial approach in accordance with international maritime standards and accepted survey methodologies.",
          p4: "Our aim is to help vessel owners, buyers, insurance companies and investors make the right decisions by providing reliable technical information.",
          p5: "Our service scope includes detailed technical inspection and reporting processes especially for yachts and vessels up to 24 meters.",
          p6: "Survey works carried out may cover the following topics:",
          p7: "Pre-purchase technical inspection (Pre-Purchase Survey)",
          p8: "Condition and status assessment surveys",
          p9: "Damage inspection and reporting",
          p10: "Technical assessments for insurance purposes",
          p11: "Valuation and technical consultancy",
          p12: "All inspections are carried out in accordance with the principle of impartiality and are supported by detailed technical reports.",
        },
        s2: {
          name: "Periodic Maintenance & General Service",
          desc: "We provide regular periodic maintenance and general service to ensure yacht owners have a safe and trouble-free experience. These services are carried out by our expert technicians to improve your vessel's performance, extend its lifespan and detect potential problems in advance. At every maintenance, the engine, electrical systems, water systems and other critical components are checked in detail.",
        },
        s3: {
          name: "Fault Detection & Repair Solutions",
          desc: "We use advanced technologies to quickly and effectively detect faults occurring on your vessel. Our expert team identifies the sources of faults and offers the most appropriate repair solutions. We work to provide reliable and permanent alternatives to our customers in solving their problems.",
        },
        s4: {
          name: "Original & Alternative Spare Parts Supply",
          desc: "We supply the original and alternative spare parts your yacht needs. Without compromising on quality and reliability, we supply the right spare parts for every vessel in the shortest time, ensuring our customers have an uninterrupted sea experience. Our spare parts are selected in accordance with international standards.",
        },

        

      },
      documents: {
        title: "Certificates and Reports",
        certificates: "Certificates",
        reports: "Sample Reports",
        view: "View",
        items: {
          cert1: "Independent Marine Engineer Registration Certificate",
          cert2: "Authorized Engineer for Ship Inspection Certificate",
          cert3: "IIMS Membership Certificate",
          cert4: "Port Control Achievement Certificate",
          report1: "Pre-purchase Survey Report - 1",
          report2: "Pre-purchase Survey Report - 2"
        }
      },
      footer: {
        contactUs: "Contact Us",
        quickAccess: "Quick Access",
        slogan: "The Best for Your Yachts and Boats",
        privacy: "Privacy Policy",
        kvkk: "KVKK",
        copyright: "© 2026 anchmarmarine.com",
      }
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') || 'tr',
  fallbackLng: 'tr',
  interpolation: { escapeValue: false }
});

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
